export const COLUMNS ={
	MENU: 'Menu',
	LIMIT_PROFILE_NAME: 'Name',
	IN_USE_BY: 'InUseBy',
	LOCKED: 'Locked'
};
